<template>
  <div class="block space-y-6 md:space-y-0 md:flex mx-8 my-6 gap-4 justify-between">
    <div class="w-full justify-between bg-white px-5 rounded-[12px] py-4 space-y-5 border border-grayLight">
      <div class="hr-container space-x-5">
        <div class="flex justify-between">
          <h1 v-if="isAdmin" class="">Projects</h1>

          <h1 v-else-if="isManager" class="">Managed Projects</h1>

          <p v-else-if="isTalent" class="font-semibold text-bodyText text-[14px]">Projects Summary</p>
          <router-link :to="{ name: 'Projects' }" class="">
          <div class="flex gap-2 items-center">
            <p class="text-primaryDarkBg text-[14px]">All Projects</p>
            <img src="@/assets/dashboard/arrow-right.svg" alt="Icon" class="w-4 h-4">
          </div>            
          </router-link>
        </div>
      </div>
      <div class="gap-4">
        <template v-if="loading">
          <SkeletonLoader v-for="n in 6" :key="n" width="100%" height="171px" />
        </template>
        <!-- Show projects for Admin -->
        <template v-else-if="isAdmin">
          <DashboardProgressChart />
          <div class="flex space-x-4 text-[14px] text-grayDark justify-center">
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-[#E2DDED] rounded-full flex justify-center items-center"></div>
              Not Started
            </div>
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-[#F9B848] rounded-full flex justify-center items-center"></div>
              Active
            </div>
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-primaryDarkBg rounded-full flex justify-center items-center"></div>
              Completed
            </div>
          </div>
        </template>

        <template v-else-if="(isTalent || isManager) && activeProjects.length > 0">
          <div v-for="project in activeProjects" :key="project.project_id" @click="goToProject(project.project_id)"
            class="w-full border border-grayLight rounded-lg py-3 px-6 space-y-4 mb-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
            <div class="flex justify-between w-full items-center">
              <h2 class="text-[18px] text-bodyText font-semibold">{{ project.project_name }}</h2>
              <div class="flex py-[6px] px-2 rounded-full bg-[#EAF3F5] space-x-2 items-center">
                <img src="@/assets/dashboard/clock.svg" alt="team" class="h-4 overlap" />
                <p class="text-[14px] text-[#348B9A]">
                  {{ project.project_status || project.status }}
                </p>
              </div>

            </div>

            <div class="flex items-center">
              <div class="relative w-[500px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden">
                <!-- Inner progress bar -->
                <div class="absolute top-0 left-0 h-full bg-primaryDark rounded-full"
                  :style="{ width: `${project.project_progress}%` }"></div>
              </div>
              <span class="ml-2 text-[12px] font-medium">{{ project.project_progress }}%</span>
            </div>

            <div class="flex justify-between w-full">
              <div class="flex -space-x-2">
                <img src="@/assets/dashboard/team-img1.svg" alt="team" class="h-8 overlap" />
                <img src="@/assets/dashboard/team-img2.svg" alt="team" class="h-8 overlap" />
                <img src="@/assets/dashboard/team-img3.svg" alt="team" class="h-8 overlap" />
                <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-8 overlap" />
              </div>
              <p class="flex text-[14px] py-2 px-4 rounded-[8px] bg-[#EBEBEC] text-primaryDarkBg font-medium">View
                project</p>
            </div>
          </div>
        </template>

        <template v-else-if="(isInvestor) && activeProjects.length > 0">
          <div v-for="project in activeProjects" :key="project.project_id" @click="goToProject(project.project_id)"
            class="w-full border border-grayLight rounded-lg py-3 px-6 space-y-4 mb-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
            <div class="flex justify-between w-full items-center">
              <h2 class="text-[18px] text-bodyText font-semibold">{{ project.project_name }}</h2>
              <div class="flex py-[6px] px-2 rounded-full bg-[#EAF3F5] space-x-2 items-center">
                <img src="@/assets/dashboard/clock.svg" alt="team" class="h-4 overlap" />
                <p class="text-[14px] text-[#348B9A]">
                  {{ project.status }}
                </p>
              </div>

            </div>

            <div class="flex items-center">
              <div class="relative w-[500px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden">
                <!-- Inner progress bar -->
                <div class="absolute top-0 left-0 h-full bg-primaryDark rounded-full"
                  :style="{ width: `${project.project_progress}%` }"></div>
              </div>
              <span class="ml-2 text-[12px] font-medium">{{ project.project_progress }}%</span>
            </div>

            <div class="flex justify-between w-full">
              <div class="flex -space-x-2">
                <img src="@/assets/dashboard/team-img1.svg" alt="team" class="h-8 overlap" />
                <img src="@/assets/dashboard/team-img2.svg" alt="team" class="h-8 overlap" />
                <img src="@/assets/dashboard/team-img3.svg" alt="team" class="h-8 overlap" />
                <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-8 overlap" />
              </div>
              <p class="flex text-[14px] py-2 px-4 rounded-[8px] bg-[#EBEBEC] text-primaryDarkBg font-medium">View
                project</p>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="w-full border border-grayLight rounded-lg py-3 px-6 space-y-4 mb-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
            <p class=" mx-auto bg- px-2 py-24">
              No active projects yet.
            </p>
          </div>
        </template>

      </div>
    </div>

    <div class="w-full bg-white px-5 rounded-[12px] py-4 space-y- border border-grayLight">

      <div class="hr-container space-x-5">
        <div class="flex justify-between">
          <p v-if="isTalent || isManager" class="font-semibold text-bodyText text-[14px]">Projects Status</p>
          <!-- <p v-else class="font-semibold text-bodyText text-[14px]">Talent Productivity Trend</p> -->
        </div>

        <div class="flex justify-between mb-8">
          <p v-if="isAdmin" class="font-semibold text-bodyText text-[14px]">Talent Productivity Trend</p>
          <p v-else-if="isInvestor" class="font-semibold text-bodyText text-[14px]">Investment Portfolio Returns</p>
          <div v-if="isAdmin" class="">
            <router-link :to="{ name: 'Talents' }" class="flex items-center gap-2">

            <p class="text-primaryDarkBg text-[14px]">View talents</p>
            <img src="@/assets/dashboard/arrow-right.svg" alt="Icon" class="w-4 h-4">
            </router-link>
          </div>
          <div v-else-if="isInvestor" class="flex gap-2 items-center">
            <p class="text-primaryDarkBg text-[14px]">Today</p>
            <img src="@/assets/dashboard/arrow-right.svg" alt="Icon" class="w-4 h-4">
          </div>
        </div>
      </div>


      <template v-if="isTalent || isManager">
        <CircularProgressChart :progress="60" />
        <div class="flex space-x-4 text-[14px] text-grayDark justify-center">
          <div class="flex items-center gap-2">
            <div class="w-2 h-2 bg-[#E2DDED] rounded-full flex justify-center items-center"></div>
            Not Started
          </div>
          <div class="flex items-center gap-2">
            <div class="w-2 h-2 bg-[#F9B848] rounded-full flex justify-center items-center"></div>
            Active
          </div>
          <div class="flex items-center gap-2">
            <div class="w-2 h-2 bg-primaryDarkBg rounded-full flex justify-center items-center"></div>
            Completed
          </div>
        </div>
      </template>

      <template v-if="isInvestor">
        <div v-for="investment in walletFlow" :key="investment.total" 
          class="w-full border border-grayLight rounded-lg py-3 px-6 space-y-2 flex flex-col justify-between items-start cursor-pointer bg-primaryBg">
          <h2 class="text-[14px] text-bodyText">Today's total returns</h2>
          <h2 class="text-[20px] font-semibold text-bodyText">+$40</h2>
          <div class=" w-full space-y-2">
            <p class="flex space-x-5 text-[12px] py-2 text-bodyText">Distribution</p>
            <div
              class="w-full border border-grayLight  rounded-lg py-3 px-6 space-y-3 flex flex-col justify-between items-start cursor-pointer bg-[#F3F8EE]">
              <h2 class="text-[13px] text-grayDark">Chowdeck</h2>
              <h2 class="text-[16px] text-grayDark font-semibold">$20</h2>
            </div>
            <div
              class="w-full border border-grayLight rounded-lg py-3 px-6 space-y-3 flex flex-col justify-between items-start cursor-pointer bg-[#F3EDF8]">
              <h2 class="text-[13px] text-grayDark">New Comma</h2>
              <h2 class="text-[16px] text-grayDark font-semibold">$50</h2>
            </div>
          </div>

        </div>

      </template>


      <template v-else-if="isAdmin">
        <TalentProductivityChart />
        <div class="flex space-x-4 text-[14px] text-grayDark justify-center">
          <div class="flex items-center gap-2">
            <div class="w-2 h-2 bg-primaryDarkBg rounded-full flex justify-center items-center"></div>
            Productivity
          </div>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import apiClient from '@/axios';
import SkeletonLoader from '@/components/SkeletonLoader.vue';
import CircularProgressChart from '../charts/CircularProgressChart.vue';
import DashboardProgressChart from '../charts/DashboardProgressChart.vue';
import TalentProductivityChart from '../charts/TalentProductivityChart.vue';


export default {
  name: 'OverviewProjectsComponent',
  components: {
    SkeletonLoader,
    CircularProgressChart,
    DashboardProgressChart,
    TalentProductivityChart,
  },
  data() {
    return {
      projects: [],
      filteredProjects: [],
      loading: true,
      managedProjects: []
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isInvestor() {
      return this.$store.getters.isInvestor;
    },
    isUser() {
      return this.$store.getters.isUser;
    },

    limitedProjects() {
      return this.filteredProjects.slice(0, 6);
    },

    activeProjects() {
      return this.projects
        .filter(project => project.project_status || project.status === 'Active')
        .slice(0, 2); // Limit to the first 2 active projects
    },

  },
  methods: {
    async fetchProjects() {
      this.loading = true; 
      try {
        let response;

        if (this.isManager) {
          response = await apiClient.get(`/web/manager/me`);
          const managerData = response.data.data;

          this.projects = managerData.projects || [];

        } else if (this.isAdmin) {
          response = await apiClient.get('/web/projects_all');
          this.projects = response.data.data || [];
        } else if (this.isTalent) {
          response = await apiClient.get('/web/talent/me');
          const talentData = response.data.data;
          this.projects = talentData.projects;
        } else if (this.isInvestor) {
          response = await apiClient.get('/web/investor/me');
          this.projects = response.data.data.projects || [];
        } else {
          console.warn("You are not authorized to access projects.");
          this.projects = [];
        }

        this.filterProjectsByStatus('Active'); // Filter projects by default status
      } catch (error) {
        console.error('Error fetching projects:', error.message);
        if (error.response) {
          console.error('Response data:', error.response.data);
          console.error('Status code:', error.response.status);
        } else if (error.request) {
          console.error('No response received:', error.request);
        }
      } finally {
        this.loading = false;
      }
    },


    filterProjectsByStatus(status) {
      if (Array.isArray(this.projects)) {
        this.filteredProjects = this.projects.filter(project => project.status === status);
      } else {
        // For safety, set to empty array if this.projects is not an array
        this.filteredProjects = [];
        console.warn('Projects is not an array:', this.projects);
      }
    },
    goToProject(projectId) {
      this.$router.push({ name: 'ProjectDetails', params: { projectId } });
    },
    async fetchWalletFlowData() {
      const projectId = this.$route.params.projectId;

      try {
        this.loading = true;
        const response = await apiClient.get(`web/wallet/inflow/chart/${projectId}`, {
          params: {
            period: this.timeframe
          }
        });

        if (response.data && response.data.status_code === 200 && response.data.data) {
          this.data = this.transformApiData(response.data.data);
        } else {
          console.error('Invalid API response format:', response.data);
          this.data = [];
        }
        this.loading = false;
      } catch (error) {
        console.error('Error fetching wallet inflow chart data:', error);
        this.loading = false;
      }
    },
    transformApiData(apiData) {
      return apiData.map(item => {
        const dateStr = item.date || (item.datetime ? item.datetime.split('T')[0] : '');

        return {
          date: this.formatDateForDisplay(dateStr),
          price: item.total,
          volume: 0
        };
      });
    },
  },
  created() {
    this.fetchProjects();
  },
};
</script>
